import { render, staticRenderFns } from "./NewConsultantSidebar.vue?vue&type=template&id=41a19717&scoped=true"
import script from "./NewConsultantSidebar.vue?vue&type=script&lang=js"
export * from "./NewConsultantSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewConsultantSidebar.vue?vue&type=style&index=0&id=41a19717&prod&lang=scss&scoped=true"
import style1 from "./NewConsultantSidebar.vue?vue&type=style&index=1&id=41a19717&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a19717",
  null
  
)

export default component.exports